import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 px-4 bg-cream" data-id="element-112">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl p-6 md:p-12 shadow-md border-2 border-success-green/30 text-center relative overflow-hidden" data-id="element-113">
        <div className="absolute top-0 left-0 w-full h-2 bg-success-green" data-id="element-114"></div>

        <ShieldCheckIcon className="w-20 h-20 text-success-green mx-auto mb-6" data-id="element-115" />

        <h2 className="text-2xl md:text-3xl font-heading font-bold text-brown-dark mb-4" data-id="element-116">
          Garantía de 7 días: "FACTURÁ O DÉJALO" — 100% satisfacción
        </h2>

        <p className="text-lg text-gray-700 font-medium mb-4 leading-relaxed" data-id="element-117">
          Si en los próximos 7 días sientes que no era lo que esperabas, me
          escribes y te devuelvo el 100%.
        </p>

        <p className="text-xl font-bold text-brown-dark" data-id="element-118">
          Sin preguntas. Sin vueltas. Sin letra pequeña.
        </p>

        <p className="text-lg text-success-green font-bold mt-4 uppercase tracking-wider" data-id="element-119">
          El riesgo es mío.
        </p>
      </div>
    </section>;
}